export const incudeSegments = ['All users'];
export const messageCategories = ['general', 'gay'];
